import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function Error({ error }: Props) {
  const { t } = useTranslation();
  const hasError =
    error.doesNotHaveNumberOrSpecialChar ||
    error.doesNotHaveUpper ||
    error.isTooShort;

  return hasError ? (
    <ul className={styles.error}>
      {error.isTooShort && (
        <li>
          <p className={styles.text}>{t("fillAccount.errors.tooShort")}</p>
        </li>
      )}
      {error.doesNotHaveUpper && (
        <li>
          <p className={styles.text}>{t("fillAccount.errors.upper")}</p>
        </li>
      )}
      {error.doesNotHaveNumberOrSpecialChar && (
        <li>
          <p className={styles.text}>
            {t("fillAccount.errors.specialCharsOrNum")}
          </p>
        </li>
      )}
    </ul>
  ) : (
    <React.Fragment />
  );
}

export { Error };
